export const SERIAL_NUMBER_REGEXP = /^(?:[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*|[a-zA-Z0-9]+)$/;
export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const EVSEID_REGEXP = /^E[123456789ABCDEFGHJKLMNPQRSTUVWXYZ]{4,}$/;
